import { useEffect } from 'react';

import useOrgUnitOmeMeetEntryData from '../../../state/orgUnitOmeMeetEntry/UseOrgUnitOmeMeetEntryData';

const useOrgUnitOmeMeetEntryTreeView = (omeMeetId, omeMeetEntryId) => {
  const { orgUnitOmeMeetEntryState, getOrgUnitsByOmeMeetIdAndOmeMeetEntryId } = useOrgUnitOmeMeetEntryData();

  useEffect(() => {
    if (omeMeetId > 0 && omeMeetEntryId > 0) {
      getOrgUnitsByOmeMeetIdAndOmeMeetEntryId(omeMeetId, omeMeetEntryId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetId, omeMeetEntryId]);

  return {
    orgUnitOmeMeetEntryState
  };
};

export default useOrgUnitOmeMeetEntryTreeView;